// Mês da competência por extenso (Janeiro, Fevereiro...), a partir de uma
// data ISO — usado tanto na tabela de parcelas quanto na de notificações.
export const renderMesCompetencia = (dataISO: string) => {
  const mes = new Date(dataISO).toLocaleDateString("pt-BR", {
    month: "long",
    timeZone: "UTC",
  });
  return mes.charAt(0).toUpperCase() + mes.slice(1);
};

// Competência no formato AAAAMM (ex.: 202609 → "Setembro/2026"), como o backend
// devolve em `parcelas[].competencia` do resumo financeiro.
export const renderCompetenciaAAAAMM = (aaaamm: number) => {
  const ano = Math.floor(aaaamm / 100);
  const mes = aaaamm % 100;
  if (!ano || mes < 1 || mes > 12) return String(aaaamm);
  return `${renderMesCompetencia(new Date(Date.UTC(ano, mes - 1, 1)).toISOString())}/${ano}`;
};
